// Objetivo de ventas del mes: una fila de `parametros` por mes (clave objetivo_ventas_AAAA-MM). No lleva migración.
import type { SupabaseClient } from '@supabase/supabase-js';
import { claveObjetivo, interpretarObjetivo, type ObjetivoMes } from '../logica/objetivo';

// null = todavía no se ha preguntado por ese mes.
export async function leerObjetivo(sb: SupabaseClient, mes: string): Promise<ObjetivoMes | null> {
  const { data, error } = await sb.from('parametros').select('valor').eq('clave', claveObjetivo(mes)).maybeSingle();
  if (error) throw new Error(error.message);
  return interpretarObjetivo(data?.valor);
}
const poner = async (sb: SupabaseClient, mes: string, valor: { valor: number | null; omitido: boolean }) => {
  const { error } = await sb.from('parametros').upsert({ clave: claveObjetivo(mes), valor });
  if (error) throw new Error(error.message);
};
export const guardarObjetivo = (sb: SupabaseClient, mes: string, valor: number) => poner(sb, mes, { valor: Math.round(valor), omitido: false });
export const omitirObjetivo = (sb: SupabaseClient, mes: string) => poner(sb, mes, { valor: null, omitido: true });
